import { useEffect, useState } from "react"

import { DEFAULT_VARIANT_TITLE } from "../../constants"
import { CartLineItem, useShopifyCart } from "../cart/CartContext"

import { ProductCartTile } from "./ProductCartTile"

export type ShopifyProductCartTileProps = {
  lineItem: CartLineItem
}

export const ShopifyProductCartTile = ({
  lineItem,
}: ShopifyProductCartTileProps) => {
  const { removeItem, changeQuantity, isLoading } = useShopifyCart()
  const { merchandise: variant, quantity, cost } = lineItem

  const imageUrl = variant.image?.url
  const soldOut = !variant.availableForSale

  const discountValue = lineItem.discountAllocations.reduce(
    (acc, curr) => acc + curr.discountedAmount.amount,
    0,
  )
  const isDiscounted = discountValue > 0

  const [displayedQuantity, setDisplayedQuantity] = useState(
    quantity.toString(),
  )
  useEffect(() => {
    setDisplayedQuantity(quantity.toString())
  }, [quantity])

  const handleChange = (newValue: string) => {
    setDisplayedQuantity(newValue.toString())
    const newQuantity = parseInt(newValue, 10)

    // If the input is invalid, don't do anything and wait until onBlur
    if (
      Number.isNaN(newQuantity) ||
      newQuantity === quantity ||
      newQuantity < 0
    ) {
      return
    }
    if (newQuantity === 0) {
      removeItem(lineItem.id)
      return
    }
    changeQuantity(lineItem.id, newQuantity - quantity)
  }

  // On blur, correct any invalid values
  const handleBlur = () => {
    if (displayedQuantity === "0") {
      removeItem(lineItem.id)
    }
    setDisplayedQuantity(quantity.toString())
  }

  return (
    <ProductCartTile
      title={variant.product.title}
      description={
        variant.title !== DEFAULT_VARIANT_TITLE ? variant.title : undefined
      }
      price={cost.totalAmount.amount.toString()}
      compareAtPrice={
        isDiscounted ? cost.subtotalAmount.amount.toString() : undefined
      }
      priceCurrencyCode={cost.totalAmount.currencyCode}
      imageUrl={imageUrl}
      soldOut={soldOut}
      quantity={displayedQuantity}
      removeItem={() => {
        removeItem(lineItem.id)
      }}
      handleChange={handleChange}
      handleBlur={handleBlur}
      loading={isLoading}
    />
  )
}
